// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-15a2ac9c] {\n  max-height: 35rem;\n  overflow: auto;\n}\n.container table[data-v-15a2ac9c]:first-child {\n  border-top: none;\n}\ntable[data-v-15a2ac9c] {\n  border-top: 0.1rem solid #acb5b6;\n  padding: 0 0 1rem 0;\n  width: 100%;\n}\n.dark table[data-v-15a2ac9c] {\n  border-top: 0.1rem solid #404040;\n}", ""]);
// Exports
module.exports = exports;
